import { Injectable } from '@angular/core';

import { CustomerType } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CustomerTypeService extends TmsWebBaseEditService<CustomerType, CustomerType> {
  constructor() {
    super('CustomerType', $localize`Customer Type`);
  }
}
